
<template>
  <div v-if="info.turnover" class="mt-4 p-3 bg-white border rounded" :class="{ 'palier-card--stat': isStat }">
      <!-- compact header (opt-in via fill): same look with or without discount tiers; without tiers it is centred in the card -->
      <div v-if="fill" class="palier-stat">
        <div class="palier-stat__body">
          <div class="palier-stat__label">{{ category }} · Chiffre d'affaires du mois</div>
          <div class="palier-stat__amount">{{ info.turnover }}</div>
          <div v-if="info.amountToNext" class="palier-stat__next">Il vous <span class="font-weight-bold">reste {{ info.amountToNext }}</span> pour passer au palier suivant !</div>
          <div v-if="palierNote" class="palier-stat__note">{{ palierNote }}</div>
        </div>
        <span v-if="hasDiscount" class="palier-stat__tag">Palier des remises</span>
      </div>
      <template v-else>
      <div class="row" >

        <div class="col-12">
          <h5 class="text-dark font-size-12 font-weight-bold">{{title}} {{ info && info.lineAmountPoint && info.lineAmountPoint.length ? 'Palier des Remises' : '' }} </h5>
          <h5 v-if="info.turnover" class="text-dark font-size-12">Vous avez réalisé un <span class="font-weight-bold"> CA mensuel de {{ info.turnover }}.</span>          
          
            <span v-if="info.amountToNext" class="ml-2 text-danger font-size-14">  Il vous <span class="font-weight-bold ">reste {{ info.amountToNext }}</span> pour passer au palier suivant !</span>
          
          </h5>
        </div>

      </div>

      <div class="text-dark font-size-12 "> {{ palierNote ? palierNote : '' }}</div>
      </template>

    <div v-if="hasDiscount" class="row mt-4">
      <div class="col-12 d-flex justify-content-between align-items-center position-relative">

      <div
        class="position-absolute w-100"
        style="height: 4px;"
        :style="`top: ${discountAvgIsInAvg ? '30px' : '10px'}; background: linear-gradient(to right, #28a745 0%, #28a745 ${completedPercent}%, #dee2e6 ${completedPercent}%, #dee2e6 100%)`"
      ></div>

        <div
          v-for="(amount, index) in info.lineAmountPoint"
          :key="index"
          class="d-flex flex-column align-items-start text-center"
          style="flex: 1; z-index: 1;"
        >

        <div v-if="discountAvgIsInAvg" class="text-center w-100">
          <small class="text-dark font-weight-bold font-size-12" style="white-space: nowrap;">{{ discountLabel(index) }}</small>
        </div>

        <div
          class="rounded-circle d-flex align-items-center justify-content-center mb-2"
          :class="{
            'text-white': isCompleted(index) || index < activeStep,
            'border border-secondary text-secondary bg-white':  !isCompleted(index) && index >= activeStep
          }"
          :style="isCompleted(index) || index < activeStep
                    ? 'background-color: #28a745;'
                    : 'background-color: white; border-color: #dee2e6;'"
          style="width: 25px; height: 25px; font-size: 12px;"
        >
          <span v-if="isCompleted(index) || index < activeStep">✔</span>
          <span v-else>{{ index + 1 }}</span>
        </div>


          <small class="text-muted" style="white-space: nowrap;">{{ prepareAmount(amount) }}</small>
          <small v-if="!discountAvgIsInAvg" class="text-dark font-weight-bold font-size-12" style="white-space: nowrap;">{{ discountLabel(index) }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: null,
    },
    // opt-in: show the compact figure when there are no discount tiers
    fill: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isStat() {
      return this.fill && !this.hasDiscount;
    },
    category() {
      return (this.title || '').replace(/[\s:]+$/, '');
    },
    hasDiscount() {
      return (
        this.info &&
        this.info.lineAmountPoint &&
        this.info.lineAmountPoint.length
      );
    },

    activeStep() {
      if (!this.info || !this.info.lineTurnoverPercent) return 0;

      const index = this.info.lineTurnoverPercent.findIndex(p => p > 0 && p < 100);

      return index === -1 ? 0 : index;
    },

    completedPercent() {
    if (!this.info || !this.info.lineTurnoverPercent) return 0;
    const completed = this.info.lineTurnoverPercent.filter(p => p === 100).length;
    const total = this.info.lineTurnoverPercent.length || 1;

    return (100 / total) * completed + ((this.info.lineTurnoverPercent[this.activeStep] || 0) * (1 / total));
  },

    isShowPalierWithTaxSymbole() {
      return process.env.VUE_APP_FEATURE_SHOW_PALIER_WITH_TAX_SYMBOLE === 'true';
    },
    palierNote() {
      return process.env.VUE_APP_PALIER_NOTE;
    },
  
    discountAvgIsInAvg() {
      return process.env.VUE_APP_FEATURE_PALIER_CENTER_DISCOUNT_AVG;
    },


  },
  methods: {

    isCompleted(index) {
        return this.info?.lineTurnoverPercent?.[index] > 0;
    },

    prepareAmount(amount) {
      const isMobile = window.innerWidth <= 768;
      
      let result = amount;
      
      if (this.isShowPalierWithTaxSymbole) {
        result = result.replace(/\s*TND$/, ' HT');
      }
      
      if (isMobile) {
        result = result.replace(/\s*(TND|HT)$/, '');
      }
      
      return result;
    },

    discountLabel(index) {
      const percent = this.info.lineDiscountPoint[index];
      if (!percent) return '\u200B';

      const isMobile = window.innerWidth <= 768; 
      return isMobile ? `${percent}%` : `Remise ${percent}%`;
    }
  },
};
</script>

<style scoped>
.palier-card--stat {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.palier-stat {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.875rem;
}
.palier-stat__body {
  flex: 1 1 12rem;
  min-width: 0;
}
.palier-stat__tag {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  background: rgba(40, 167, 69, 0.1);
  color: #1e7e34;
  font-size: 0.6875rem;
  font-weight: 600;
  white-space: nowrap;
}
.palier-stat__label {
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #667085;
}
.palier-stat__amount {
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.3;
  color: #101828;
  font-variant-numeric: tabular-nums;
}
.palier-stat__next {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #b42318;
}
.palier-stat__note {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #475467;
}
</style>